import Vue from "vue";
import Vuex from "vuex";
import login from "../modules/login";
import partes from "../modules/partes";
import clientes from "../modules/clientes";
import usuarios from "../modules/usuarios";
import grupos from "../modules/grupos";
import tipoUsuario from "../modules/tipoUsuario";
import arditimer from "../modules/arditimer";
import accionesMasivas from "../modules/accionesMasivas";
import misGrupos from "../modules/misGrupos";
import horario from "../modules/horario";
import estado from "../modules/estado";
import equipos from "../modules/equipos";
import asientos from "../modules/asientos";
import materiales from "../modules/materiales";
import contratos from "../modules/contratos";
import componentes from "../modules/componentes";
import notificaciones from "../modules/notificaciones";
import listadoAcciones from "../modules/listadoAcciones";
import resumen from "../modules/resumen";
import moverAcciones from "../modules/moverAcciones";
import acciones from "../modules/acciones";
import informe from "../modules/informe";
import calculoHoras from "../modules/calculoHoras";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false, // Indica si existe un proceso de carga
    //Snackbar
    snackbar: false,
    mensaje: "",
    tipo: "",
    //FIN Snackbar
    intended: {},
    // snackbar: false,
    // mensaje: '',
    // tipo: '',
    //FIN Snackbar
    arraySnackbar: [],
    contados: 1,
  },
  mutations: {
    SET_LOADING(state, valor) {
      state.loading = valor;
    },
    SET_INTENDED(state, intended) {
      state.intended = intended;
    },
    // SET_SNACKBAR(state, valores) {
    //   state.snackbar = valores.snackbar;
    //   if (valores.tipo !== null) {
    //     state.tipo = valores.tipo;
    //   }
    //   if (valores.mensaje !== null) {
    //     state.mensaje = valores.mensaje;
    //   }
    // },
    SET_SNACKBAR(state, propiedades) {
      state.arraySnackbar.push({
        id: state.contados,
        visible: true,
        currentTime: 0,
        tipo: propiedades.tipo,
        texto: propiedades.mensaje,
        parado: false,
        mostrar: false,
      });
      state.contados++;
    },
    SET_ELIMINARSNACKBAR(state) {
      state.arraySnackbar = state.arraySnackbar.filter(
        (s) => s.visible !== false
      ); // snackbars = a todos los snackbars menos el que este en visivilidad falsa
    },
  },
  actions: {
    setLoading({ commit }, valor) {
      commit("SET_LOADING", valor);
    },
    setIntended({ commit }, intended) {
      commit("SET_INTENDED", intended);
    },
    setSnackbar({ commit }, propiedades) {
      commit("SET_SNACKBAR", propiedades);
    },
    setEliminarSnackbar({ commit }) {
      commit("SET_ELIMINARSNACKBAR");
    },
  },
  modules: {
    login,
    partes,
    clientes,
    usuarios,
    grupos,
    tipoUsuario,
    arditimer,
    accionesMasivas,
    misGrupos,
    horario,
    estado,
    equipos,
    asientos,
    // materiales,
    materiales,
    contratos,
    componentes,
    notificaciones,
    listadoAcciones,
    resumen,
    moverAcciones,
    acciones,
    informe,
    calculoHoras
  },
});
